import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TicketCloseComponent } from './ticket-close.component';
import { TicketCloseRoutingModule } from './ticket-close-routing.module';
import { SharedModule } from '../shared/shared.module';

@NgModule({
  declarations: [TicketCloseComponent],
  imports: [
    CommonModule,
    TicketCloseRoutingModule,
    SharedModule
  ]
})
export class TicketCloseModule { }
